import React from "react";
import { Box } from "@mui/material";
import Typography from "components/basic/typography";
import { EVENT_TYPES } from "../eventTypes";

const Legend: React.FC = () => (
  <Box
    sx={{
      display: "flex",
      flexWrap: "wrap",
      gap: 2,
      alignItems: "center",
      px: 1,
      py: 1,
    }}
  >
    {EVENT_TYPES.map((item) => (
      <Box
        key={item.id}
        sx={{ display: "flex", alignItems: "center", gap: 0.75 }}
      >
        <Box
          sx={{
            width: 14,
            height: 14,
            borderRadius: "3px",
            backgroundColor: item.color,
          }}
        />
        <Typography variant="caption">{item.label}</Typography>
      </Box>
    ))}
  </Box>
);

export default Legend;
